import { collection, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const setupWebNotifications = async (servicioId, userEmail) => {
    // Verificar soporte de notificaciones
    if (!('Notification' in window)) {
        console.log('Este navegador no soporta notificaciones');
        return;
    }

    try {
        // Solicitar permiso
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            // Actualizar el estado del vigilante en Firestore
            const vigilantesRef = collection(db, 'servicios', servicioId, 'vigilantes');
            const q = query(vigilantesRef, where('email', '==', userEmail));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const vigilanteDoc = querySnapshot.docs[0];
                await updateDoc(vigilanteDoc.ref, {
                    notificationsEnabled: true,
                    platform: 'web',
                    lastUpdate: new Date()
                });
            }
        }
    } catch (error) {
        console.error('Error configurando notificaciones:', error);
    }
};

export const showNotification = (title, body, data = {}) => {
    if (Notification.permission === 'granted') {
        const notification = new Notification(title, {
            body,
            icon: '/logo192.png', // Asegúrate de tener este archivo en tu carpeta public
            data
        });

        notification.onclick = function() {
            window.focus();
            // Si tienes datos específicos en la notificación, puedes usarlos aquí
            if (data.url) {
                window.location.href = data.url;
            }
        };
    }
};